module.exports = __webpack_public_path__ + "static/media/control-chofer-rojo.a9563914.png";